/**
 * Moviq Sports — opmaak van de Shopify Forms-pop-up (nieuwsbrief / Moviq Club).
 *
 * Shopify Forms rendert de pop-up in een shadow root, dus gewone theme-CSS komt er niet bij.
 * Dit script hangt één <style> in die shadow root, in dezelfde stijl als de footer-nieuwsbrief:
 * sage vlak, zwarte hoofdletterkop met gele accentlijn, zwart omlijnd invulveld, gele knop,
 * rechte hoeken, geen schaduw.
 *
 * De klassennamen van de app eindigen op een wisselende hash (bv. _formSubmitButton_48bzm_124),
 * daarom selecteren we op het vaste deel: [class*="_formSubmitButton_"].
 * Teksten, korting en de app-instellingen zelf beheer je in de Shopify Forms-editor.
 */
(function () {
  var STYLE_ID = 'moviq-forms-style';

  var CSS = `
    /* ---------- Venster ---------- */
    [class*="_formContainer_"] {
      background: #8a9a7a !important;
      border: 2px solid #000 !important;
      border-radius: 0 !important;
      box-shadow: none !important;
      font-family: 'Poppins', sans-serif !important;
    }
    [class*="_gridItemContent_"] { padding: 36px 32px 28px !important; text-align: left !important; }
    [class*="_formHeader_"] { text-align: left !important; margin-bottom: 20px !important; }

    /* ---------- Kop + gele accentlijn ---------- */
    [class*="_textHeading_"] {
      margin: 0 0 14px !important;
      font-size: 34px !important;
      font-weight: 700 !important;
      line-height: 0.98 !important;
      letter-spacing: -0.025em !important;
      text-transform: uppercase !important;
      text-align: left !important;
      color: #000 !important;
    }
    [class*="_textHeading_"]::after {
      content: '';
      display: block;
      width: 56px;
      height: 3px;
      margin-top: 14px;
      background: #f2c94c;
    }
    [class*="_textBody_"], [class*="_textBody_"] p {
      text-align: left !important;
      font-size: 15px !important;
      line-height: 1.6 !important;
      color: #000 !important;
    }

    /* ---------- Invulveld ---------- */
    [class*="_formInputField_"] {
      border: 2px solid #000 !important;
      border-radius: 0 !important;
      box-shadow: none !important;
      background: #fff !important;
      color: #000 !important;
      font-size: 15px !important;
    }
    [class*="_formInputField_"]:focus { outline: 2px solid #f2c94c !important; outline-offset: 2px !important; }
    [class*="_formInputFieldLabel_"] { color: rgb(0 0 0 / 0.55) !important; }

    /* ---------- Knop ---------- */
    [class*="_formSubmitButton_"] {
      background: #f2c94c !important;
      color: #000 !important;
      border: 2px solid #000 !important;
      border-radius: 0 !important;
      font-weight: 700 !important;
      font-size: 13px !important;
      letter-spacing: 0.08em !important;
      text-transform: uppercase !important;
      padding: 16px !important;
      transition: background-color 0.2s ease, color 0.2s ease !important;
    }
    @media (hover: hover) {
      [class*="_formSubmitButton_"]:hover { background: #000 !important; color: #f2c94c !important; }
    }

    /* ---------- Kleine lettertjes en sluitknop ---------- */
    [class*="_formDisclaimer_"], [class*="_formDisclaimer_"] p {
      text-align: left !important;
      padding: 0 !important;
      font-size: 12px !important;
      color: rgb(0 0 0 / 0.7) !important;
    }
    [class*="_formCloseButton_"] {
      display: grid !important;
      place-items: center !important;
      width: 32px !important;
      height: 32px !important;
      background: #000 !important;
      color: #fff !important;
      border-radius: 0 !important;
    }
    [class*="_formCloseButton_"] svg { width: 12px !important; height: 12px !important; }
    [class*="_formCloseButton_"] svg * { stroke: #fff !important; fill: #fff !important; }

    /* ---------- Verticaal teaser-tabblad (na sluiten) ---------- */
    button[class*="_teaser"] {
      position: fixed !important;
      right: 0 !important;
      bottom: 180px !important;
      width: auto !important;
      min-width: 0 !important;
      padding: 18px 12px !important;
      border: 2px solid #000 !important;
      border-right: 0 !important;
      border-radius: 0 !important;
      writing-mode: vertical-rl !important;
      transform: rotate(180deg) !important;
      font-family: 'Poppins', sans-serif !important;
      font-size: 13px !important;
      font-weight: 700 !important;
      letter-spacing: 0.08em !important;
      text-transform: uppercase !important;
      background: #8a9a7a !important;
      color: #000 !important;
      box-shadow: none !important;
      z-index: 999999 !important;
    }
    button[class*="_teaser"] svg,
    button[class*="_teaser"] [class*="close" i],
    button[class*="_teaser"] [aria-label*="close" i],
    button[class*="_teaser"] [aria-label*="sluit" i] {
      display: none !important;
    }

    @media (max-width: 480px) {
      [class*="_gridItemContent_"] { padding: 28px 20px 22px !important; }
      [class*="_textHeading_"] { font-size: 28px !important; }
      button[class*="_teaser"] { bottom: 120px !important; }
    }
  `;

  function styleShopifyForms() {
    document.querySelectorAll('shopify-forms-embed').forEach(function (embed) {
      var root = embed.shadowRoot;
      if (!root || root.getElementById(STYLE_ID)) return;
      var style = document.createElement('style');
      style.id = STYLE_ID;
      style.textContent = CSS;
      root.appendChild(style);
    });
  }

  styleShopifyForms();

  /* Shopify Forms laadt later (na scrollen/tijd) en kan opnieuw renderen: dan opnieuw toepassen. */
  new MutationObserver(styleShopifyForms).observe(document.body, { childList: true, subtree: true });
})();
